import { SVGProps } from 'react';

const LogoSmallIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M16.3147 17.4918H14.7699C14.4105 17.4905 14.1195 17.1995 14.1182 16.8395V13.6091C14.1155 13.2491 13.8245 12.9581 13.4665 12.9568H10.4948C10.1354 12.9581 9.84444 13.2491 9.84309 13.6091V16.8341C9.84041 17.1941 9.54942 17.485 9.19137 17.4864H7.73773C7.31532 17.4729 6.90632 17.6366 6.6113 17.9398L3.73486 20.6897C8.3747 25.1111 15.6657 25.1002 20.2921 20.664L17.4425 17.9398C17.1488 17.6326 16.7385 17.4688 16.3147 17.4864"
        fill="#FF642B"
      />
      <path
        d="M5.9529 15.7866V10.7089C5.97033 10.3016 5.74236 9.92264 5.37493 9.74671L0.91344 7.38379C-0.773531 11.4614 -0.0909649 16.1358 2.68892 19.5597L5.47819 16.8937C5.79064 16.6108 5.96363 16.2048 5.95156 15.7839"
        fill="#FF642B"
      />
      <path
        d="M13.3123 6.19962L16.7479 8.37307C17.0899 8.59096 17.523 8.6072 17.8797 8.41638L22.4083 6.01421C20.4048 2.51314 16.7788 0.253073 12.7571 0V5.19138C12.7531 5.60144 12.9637 5.98308 13.3123 6.19962Z"
        fill="#FF642B"
      />
      <path
        d="M7.26043 8.36076L10.6692 6.18595C11.0233 5.97618 11.2351 5.59048 11.2217 5.17907V0.0012207C7.21216 0.261061 3.59818 2.51571 1.59741 6.0046L6.12997 8.40812C6.48802 8.59624 6.91848 8.57729 7.26043 8.36076Z"
        fill="#FF642B"
      />
      <path
        d="M23.0897 7.39478L18.6308 9.75905C18.2701 9.9431 18.0462 10.3166 18.0529 10.7213V15.7421C18.0475 16.1617 18.2192 16.5636 18.5249 16.8505L21.3343 19.5369C24.0927 16.117 24.7659 11.4629 23.0883 7.40019"
        fill="#FF642B"
      />
    </svg>
  );
};

export default LogoSmallIcon;
